export function determineAmazonGiftCardAmount(rentalAmount, giftCardTiers) {
  if (!giftCardTiers.length) {
    return 0.00;
  }

  const sortedTiers = giftCardTiers.sort((a, b) => {
    return b.min - a.min;
  });

  for (let i = 0; i < sortedTiers.length; i++) {
    if (+rentalAmount >= sortedTiers[i].min) {
      return sortedTiers[i].amount;
    }
  }

  return 0.00;
};
